var _excluded = ["align", "children", "color", "italic", "tag", "type", "gradientText", "weight", "className"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import withCssProps from '../../hocs/withCssProps';
import { HXSText, HSMText, HMDText, HLGText, HXLText, HXXLText, SSMText, SMDText, SLGText, LSMText, LMDText, LLGText, BSMText, BMDText, BLGText, NMDText, NLGText, NXLText, NXXLText } from './StyledText';
var types = {
  'heading-xs': HXSText,
  'heading-sm': HSMText,
  'heading-md': HMDText,
  'heading-lg': HLGText,
  'heading-xl': HXLText,
  'heading-xxl': HXXLText,
  'subtitle-sm': SSMText,
  'subtitle-md': SMDText,
  'subtitle-lg': SLGText,
  'label-sm': LSMText,
  'label-md': LMDText,
  'label-lg': LLGText,
  'body-sm': BSMText,
  'body-md': BMDText,
  'body-lg': BLGText,
  'number-md': NMDText,
  'number-lg': NLGText,
  'number-xl': NXLText,
  'number-xxl': NXXLText
};
var Text = withCssProps(function (_ref) {
  var _ref$align = _ref.align,
    align = _ref$align === void 0 ? 'left' : _ref$align,
    children = _ref.children,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'black' : _ref$color,
    _ref$italic = _ref.italic,
    italic = _ref$italic === void 0 ? false : _ref$italic,
    _ref$tag = _ref.tag,
    tag = _ref$tag === void 0 ? 'span' : _ref$tag,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'body-lg' : _ref$type,
    gradientText = _ref.gradientText,
    _ref$weight = _ref.weight,
    weight = _ref$weight === void 0 ? null : _ref$weight,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var StyledText = types[type];
  return /*#__PURE__*/React.createElement(StyledText, _extends({
    className: className,
    as: tag,
    align: align,
    color: color,
    italic: italic,
    weight: weight,
    type: type,
    gradientText: gradientText
  }, props), children);
});
Text.propTypes = {
  align: PropTypes.oneOf(['left', 'right', 'center', 'justify']),
  children: PropTypes.node,
  color: PropTypes.string,
  type: PropTypes.oneOf(['heading-xs', 'heading-sm', 'heading-md', 'heading-lg', 'heading-xl', 'heading-xxl', 'subtitle-sm', 'subtitle-md', 'subtitle-lg', 'label-sm', 'label-md', 'label-lg', 'body-sm', 'body-md', 'body-lg', 'number-md', 'number-lg', 'number-xl', 'number-xxl']),
  italic: PropTypes.bool,
  weight: PropTypes.oneOf(['bold', 'normal', '400', '500', '600']),
  tag: PropTypes.oneOf(['span', 'p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'label', 'li', 'div', 'a']),
  className: PropTypes.string,
  gradientText: PropTypes.bool
};
Text.displayName = 'Text';
export { Text };